import React, { useState, useEffect } from "react";
import { Alert, Button, Col, Form, message, Modal, Row } from "antd";

import FormInput from "components/FormInput/FormInput";
import FormAutoComplete from "components/FormAutoComplete/FormAutoComplete";
import Locale from "react-intl-universal";

const { useForm } = Form;
const { confirm } = Modal;

const EventAlert = ({ event }) => {
  const eventsToAlert = [
    "legally Incapacitated / comatose",
    "tpd",
    "critically ill",
    "death",
  ];

  if (eventsToAlert.includes(event.toLowerCase())) {
    return (
      <Alert
        type="warning"
        message="If Insurable at current health condition. Please refer to the Financial Risk Ratio."
        showIcon
        style={{ width: "98%", margin: "-10px auto 20px auto" }}
      />
    );
  } else {
    return null;
  }
};

const AddEventModal = ({
  defaultValues,
  onOk,
  onClose,
  onRemove,
  suggestions,
  visible,
}) => {
  const [form] = useForm();
  const [selectedEvent, setSelectedEvent] = useState("");
  const [selections, setSelections] = useState([]);

  useEffect(() => {
    if (defaultValues) {
      setSelectedEvent(defaultValues.event);
      form.setFieldsValue(defaultValues);
    }
  }, [form, defaultValues]);

  const handleOnOkButtonClick = async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach((field) => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: Locale.get("estateContingencyPlan.removeConfirmMsg"),
      okText: Locale.get("estateContingencyPlan.yes"),
      onOk() {
        onRemove();
      },
      onClose() {},
    });
  };

  const handleOnSearchEvents = (inputValue) => {
    const newSelections = inputValue
      ? suggestions.filter((suggestion) => {
          const upperCaseSuggestionValue = suggestion.value.toUpperCase();
          return upperCaseSuggestionValue.includes(inputValue.toUpperCase());
        })
      : [];

    setSelections(newSelections);
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          {Locale.get("estateContingencyPlan.remove")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("estateContingencyPlan.save")}
        </Button>,
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          {Locale.get("estateContingencyPlan.cancel")}
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          {Locale.get("estateContingencyPlan.addEvent")}
        </Button>,
      ];

  return (
    <Modal
      title={Locale.get("estateContingencyPlan.evenTitle")}
      visible={visible}
      onOk={handleOnOkButtonClick}
      onCancel={onClose}
      footer={footer}
      width="60%"
      destroyOnClose
    >
      <Form form={form} preserve={false}>
        <Row gutter={16}>
          <Col span={24}>
            <FormAutoComplete
              name="event"
              label={Locale.get("estateContingencyPlan.eventType")}
              requiredErrorMessage={Locale.get(
                "estateContingencyPlan.errMsgEventType"
              )}
              placeholder={Locale.get("estateContingencyPlan.eventPlaceholder")}
              selections={selections}
              onSearch={handleOnSearchEvents}
              onChange={(selectedEvent) => setSelectedEvent(selectedEvent)}
            />
          </Col>
          <EventAlert event={selectedEvent} />
          <Col span={24}>
            <FormInput
              label={Locale.get("estateContingencyPlan.solution")}
              name="solution"
              requiredErrorMessage={Locale.get(
                "estateContingencyPlan.errMsgSolution"
              )}
            />
          </Col>
          <Col span={24}>
            <FormInput
              label={Locale.get("estateContingencyPlan.toDateStatus")}
              name="toDateStatus"
            />
          </Col>
          <Col span={24}>
            <FormInput
              label={Locale.get("estateContingencyPlan.detail")}
              name="remarks"
              placeholder={Locale.get(
                "estateContingencyPlan.detailPlaceholder"
              )}
              type="textArea"
            />
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddEventModal;
